import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle() {
    document.querySelectorAll('.post .card').forEach((e) => {
      e.classList.add('!duration-0')
    })

    if (localStorage.theme === 'dark') {
      localStorage.removeItem('theme')
      document.documentElement.classList.remove('dark')
    } else {
      localStorage.theme = 'dark'
      document.documentElement.classList.add('dark')
    }

    setTimeout(() => {
      // clearTimeout(timeout)
      document.querySelectorAll('.post .card').forEach((e) => {
        e.classList.remove('!duration-0')
      })
    }, 500)
  }
}
